// =============================================================================
// Session cache for the dashboard (DynamicDashboard).
//
// Two stores:
//   • configs   — dashboardKey → the /api/Dashboard/config payload. Config is
//                 DB-authored layout metadata that changes rarely (admin edits),
//                 so a session-cached copy is served WITHOUT revalidation; a
//                 hard refresh naturally picks up config changes.
//   • responses — request key (url + querystring) → widget data payload.
//                 Served stale-while-revalidate: the grid binds instantly from
//                 here while the same request re-fires in the background and
//                 refreshes both the screen and this store. Keyed by the full
//                 request, so every filter combo the user has viewed this
//                 session rebinds instantly too.
//
// Same lifecycle as refDataCache / searchCache: module-level (survives route
// changes, not a hard reload) and wiped by clearAuth() on logout / 401.
// =============================================================================

const configs = new Map();
const responses = new Map();

export function peekConfig(dashboardKey) {
  return configs.get(dashboardKey);
}

export function putConfig(dashboardKey, config) {
  if (config) configs.set(dashboardKey, config);
}

export function peekResponse(key) {
  return responses.get(key);
}

export function putResponse(key, data) {
  if (data) responses.set(key, data);
}

export function clear() {
  configs.clear();
  responses.clear();
}
